import { Component, inject } from '@angular/core';
import { BillingService } from '@tytapp/app/billing.service';
import { FollowButton, HomeCard, HomeCardComponentType, HomeCardIcon, HomeCardLink } from '@tytapp/app/pages/home-page/home-cards.service';
import { HostApi } from '@tytapp/host-api/host-api.service';
import { UserService } from '@tytapp/user/user.service';

@Component({
    templateUrl: './home-support-c2a.component.html',
    styleUrls: ['./home-support-c2a.component.scss']
})
export class HomeSupportC2AComponent implements HomeCardComponentType {
    private userService = inject(UserService);
    private billingService = inject(BillingService);
    private hostApi = inject(HostApi);

    get billingEnabled() {
        return this.hostApi.capabilities.includes('web_billing:membership')
            || this.hostApi.capabilities.includes('platform_billing:membership');
    }

    get webBillingEnabled() {
        return this.hostApi.capabilities.includes('web_billing:membership')
    }

    card: HomeCard;
    fullBleed = true;

    get hidden() {
        return this.userService.audienceType === 'member' && !this.webBillingEnabled;
    }
}